const animatedSelector = "[data-animated]";
const groupSelector = "[data-animated-group]";
const visibleClass = "is-visible";
const defaultStagger = 80;

let initialized = false;

export function initAnimatedElements() {
  if (initialized) return;

  const elements = document.querySelectorAll(animatedSelector);

  if (elements.length === 0 || !("IntersectionObserver" in window)) return;

  initialized = true;
  setGroupDelays();
  observeElements(elements);
}

function setGroupDelays() {
  document.querySelectorAll(groupSelector).forEach(function(group) {
    const stagger = getStagger(group);

    group.querySelectorAll(animatedSelector).forEach(function(element, index) {
      element.style.setProperty("--animated-delay", index * stagger + "ms");
    });
  });
}

function observeElements(elements) {
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;

      entry.target.classList.add(visibleClass);
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: "0px 0px -10% 0px",
    threshold: 0.15
  });

  elements.forEach(function(element) {
    observer.observe(element);
  });
}

function getStagger(group) {
  const value = group.getAttribute("data-animated-stagger");
  const stagger = Number(value);

  return value !== null && Number.isFinite(stagger) && stagger >= 0 ? stagger : defaultStagger;
}
